import { motion } from "framer-motion";
import { GradientButton, GhostButton } from "../primitives";

export default function FinalCTA() {
  return (
    <section data-testid="final-cta" className="relative mx-auto max-w-7xl px-5 pb-24 lg:px-8 lg:pb-32">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className="relative overflow-hidden rounded-[2rem] border border-white/10 bg-ink-soft px-8 py-16 text-center sm:px-16 sm:py-20"
      >
        <div className="absolute -left-20 top-0 h-64 w-64 rounded-full bg-brand/25 blur-[100px]" />
        <div className="absolute -right-20 bottom-0 h-64 w-64 rounded-full bg-brand-gold/20 blur-[100px]" />
        <div
          className="absolute inset-0 opacity-[0.06]"
          style={{ backgroundImage: "radial-gradient(circle at 1px 1px, #fff 1px, transparent 0)", backgroundSize: "28px 28px" }}
        />

        <div className="relative">
          <h2 className="mx-auto max-w-2xl font-heading text-3xl font-semibold leading-tight text-white sm:text-4xl lg:text-5xl">
            Let's build something your business is <span className="text-gradient">proud of</span>.
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-base text-muted-foreground">
            Book a free, no-pressure consultation. We'll talk through your goals and show you exactly how we can help.
          </p>
          <div className="mt-9 flex flex-col justify-center gap-3 sm:flex-row">
            <GradientButton to="/contact" data-testid="final-cta-book">Book a Free Consultation</GradientButton>
            <GhostButton to="/packages" data-testid="final-cta-packages">View Packages</GhostButton>
          </div>
        </div>
      </motion.div>
    </section>
  );
}
